import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.77307 0.9L0.243073 10.48C-0.446927 11.68 0.413073 13.18 1.80307 13.18H12.8631C14.2531 13.18 15.1131 11.68 14.4231 10.48L8.89307 0.9C8.20307 -0.3 6.47307 -0.3 5.77307 0.9Z",
		fill: "#EE2B2B"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.80307 8.69H6.87307L6.64307 3.88H8.03307L7.80307 8.69ZM7.98307 10.67H6.68307V9.28H7.98307V10.67Z",
		fill: "white"
	})]
});
export default SvgWarningRed;
